// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-btn[data-v-4a64e403]{flex:0 0 24px;--tw-bg-opacity:1;background-color:rgba(212,212,216,var(--tw-bg-opacity))}.card-btn-selected[data-v-4a64e403]{flex:0 0 80px;--tw-bg-opacity:1;background-color:rgba(225,28,39,var(--tw-bg-opacity))}", ""]);
// Exports
module.exports = exports;
